import React ,{useContext} from 'react'
import { HeroContext } from './App';
export default function GreenLanternItem(props) {
    const {handleUpdateGoods}=useContext(HeroContext)
    const {item,value}=props
    return (
        <div>
            <p>
                greenlantern {item} 
                <button
                onClick={()=>{
                    handleUpdateGoods('greenlantern',{[item]:Number([value])-1})
                }}
                >
                    -
                </button>
                <span> {value}</span>
                <button
                onClick={()=>{
                    handleUpdateGoods('greenlantern',{[item]:Number([value])+1})
                }}
                >
                     +
                </button>
            </p>  
        </div>
    )
}
